import * as React from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_filter_preset_wizard/AddFilterPresetForm.scss';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import { withRouter } from 'react-router';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import Input from '../../components/Input';
import { hideFilterPreset } from '../../redux/actions/general/filter_preset';

const AddFilterPresetForm = (props) => {
  const _handleSubmit = (edit) => {
    props.change('edit', edit);

    setTimeout(() => props.submit(), 10);
  };

  return (
    <Form className={styles.wrapper}>
      <div className={styles.form}>
        <Field
          name='name'
          component={Input}
          label={__('table.columns.add_filter_preset')}
          maxLength={60}
        />

        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={hideFilterPreset}
            className={styles.button}
          />
          <ButtonGroup>
            <Button
              lightBlue
              medium
              disabled={!props.values?.name}
              middleText={__('button.create')}
              spinning={props.submitting}
              onClick={() => _handleSubmit(false)}
            />
          </ButtonGroup>
        </div>
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    values: getFormValues('add_filter_preset_wizard.add_filter_preset')(state),
  };
};

export default withRouter(
  reduxForm({
    form: 'add_filter_preset_wizard.add_filter_preset',
  })(
    connect(
      mapStateToProps,
      null
    )(subscribe(Localization, 'localization')(AddFilterPresetForm))
  )
);
